import { useTranslation } from 'react-i18next';

import { Button } from '@mantine/core';
import { IconChecks } from '@tabler/icons-react';
import { notificationApi } from '@sinups/ui-kit';

export const MarkAllAsReadButton = () => {
  const { t } = useTranslation(['ds']);

  const [markAsRead] = notificationApi.useMarkAsReadMutation();

  const onReadAllHandler = () => {
    markAsRead({ id: null, value: 1 });
  };

  return (
    <Button
      variant="subtle"
      size="xs"
      fw={400}
      leftSection={<IconChecks size={14} />}
      onClick={onReadAllHandler}
    >
      {t('ds:notifications.modal.allAsReadButton')}
    </Button>
  );
};
